import Hero from "@/components/Hero";
import Purpose from "@/components/Purpose";
import Services from "@/components/Services";
import ProjectsLoop from "@/components/ProjectsLoop";
import ClientsMarquee from "@/components/ClientsMarquee";
import Credentials from "@/components/Credentials";
import Founders from "@/components/Founders";
import Strengths from "@/components/Strengths";
import Process from "@/components/Process";
import Contact from "@/components/Contact";

export default function Home() {
  return (
    <main>
      <Hero />
      <Purpose />
      <Services />
      <ProjectsLoop />
      <ClientsMarquee />
      <Credentials />
      <Founders />
      <Strengths />
      <Process />
      <Contact />
    </main>
  );
}
